export const CUSTOMER_INFORMATION_STEP = 1;
export const USERS_STEP = 2;
export const SELECT_PRODUCTS_STEP = 3;
export const ESTIMATED_TOTAL_STEP = 4;
// Swapped order: Legal Agreements now comes before Payment
export const AGREEMENTS_STEP = 5;
export const PAYMENT_STEP = 6;
export const CONFIRMATION_STEP = 7;
export const TOTAL_STEPS = 7;
